import React from "react";

const LandingFooter = ({ style = {} }) => {
  const isMobile = window.innerWidth < 768;
  const isDesktop = window.innerWidth >= 1024;

  return (
    <footer
      style={{
        backgroundColor: '#EEE7D8',
        paddingTop: isMobile ? '20px' : '80px',
        paddingBottom: isMobile ? '40px' : '80px',
        paddingLeft: isMobile ? '20px' : (isDesktop ? '80px' : '60px'),
        paddingRight: isMobile ? '20px' : (isDesktop ? '80px' : '60px'),
        ...style
      }}
    >
      <div
        style={{
          maxWidth: '1400px',
          margin: '0 auto',
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: isMobile ? '40px' : '60px'
        }}
      >
        <div style={{ flexShrink: 0 }}>
          <img
            src="https://customer-assets.emergentagent.com/job_cookbookai/artifacts/9q6z01vn_wellby-logo.svg"
            alt="Wellby"
            style={{
              height: isDesktop ? '300px' : '225px',
              width: 'auto'
            }}
          />
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: isMobile ? 'center' : 'flex-end',
            gap: '24px',
            textAlign: isMobile ? 'center' : 'right'
          }}
        >
          <div>
            <p
              style={{
                fontFamily: "'Bricolage Grotesque', sans-serif",
                fontSize: isDesktop ? '18px' : '16px',
                color: '#51120A',
                marginBottom: '12px',
                fontWeight: '600'
              }}
            >
              Connect with Brittany!
            </p>
            <div
              style={{
                fontFamily: "'Bricolage Grotesque', sans-serif",
                fontSize: isDesktop ? '16px' : '14px',
                color: '#51120A'
              }}
            >
              <a
                href="https://www.instagram.com/britt_blume/?hl=en"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: '#51120A',
                  textDecoration: 'none',
                  transition: 'opacity 0.2s'
                }}
                onMouseEnter={(e) => (e.currentTarget.style.opacity = '0.7')}
                onMouseLeave={(e) => (e.currentTarget.style.opacity = '1')}
              >
                Instagram
              </a>
              <span style={{ margin: '0 12px', opacity: '0.5' }}>|</span>
              <a
                href="https://substack.com/@brittblume?utm_source=user-menu"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: '#51120A',
                  textDecoration: 'none',
                  transition: 'opacity 0.2s'
                }}
                onMouseEnter={(e) => (e.currentTarget.style.opacity = '0.7')}
                onMouseLeave={(e) => (e.currentTarget.style.opacity = '1')}
              >
                Substack
              </a>
              <span style={{ margin: '0 12px', opacity: '0.5' }}>|</span>
              <a
                href="https://delightfulcreative.com/"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: '#51120A',
                  textDecoration: 'none',
                  transition: 'opacity 0.2s'
                }}
                onMouseEnter={(e) => (e.currentTarget.style.opacity = '0.7')}
                onMouseLeave={(e) => (e.currentTarget.style.opacity = '1')}
              >
                Design Studio
              </a>
            </div>
          </div>

          <div
            style={{
              fontFamily: "'Bricolage Grotesque', sans-serif",
              fontSize: isDesktop ? '14px' : '12px',
              color: '#51120A',
              opacity: '0.7'
            }}
          >
            <a
              href="/terms"
              style={{
                color: '#51120A',
                textDecoration: 'none',
                transition: 'opacity 0.2s'
              }}
              onMouseEnter={(e) => (e.currentTarget.style.opacity = '1')}
              onMouseLeave={(e) => (e.currentTarget.style.opacity = '0.7')}
            >
              Terms and Conditions
            </a>
            <span style={{ margin: '0 12px' }}>|</span>
            <a
              href="/privacy"
              style={{
                color: '#51120A',
                textDecoration: 'none',
                transition: 'opacity 0.2s'
              }}
              onMouseEnter={(e) => (e.currentTarget.style.opacity = '1')}
              onMouseLeave={(e) => (e.currentTarget.style.opacity = '0.7')}
            >
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;
